// Injected from package.json by the npm scripts as REACT_APP_VERSION.
export const APP_VERSION = process.env.REACT_APP_VERSION || '';
